import {takeEvery,all,put,select,call} from 'redux-saga/effects';
import * as actions from './actions';
import * as selectors from './selectors'
import * as settingsApi from '../api/settingsApi';
import { searchToFilters } from '../common/urlUtils';
import actionFactory from '../webcommon/header/filterheader/actions';
import * as filterHeaderSelectors from '../webcommon/header/filterheader/selectors';
import { msalInstance } from '../webcommon/common/httpConnection/adfsConnection';
const filterHeaderId = 'Settings';

export const filterHeaderActions = actionFactory(filterHeaderId);

export function* StatusPageConnected(api, action){
    try {
        const initialised = yield (select(selectors.getStatusPageInitialised));
        if (!initialised) {
            yield put(actions.setStatusPageLoading(true));
            const filterDefinitions = yield select(selectors.getFilterDefinitions);
            yield put(filterHeaderActions.setFilterDefinitions(filterDefinitions));
            const defaultFilters = yield select(selectors.getDefaultFilters);
            yield put(filterHeaderActions.setDefaultFilters(defaultFilters));
            if (action.search === '') {
                yield put(filterHeaderActions.resetFilters());
            } else {
                const filters = searchToFilters(action.search, filterDefinitions, defaultFilters);
                yield put(filterHeaderActions.setFilters(filters));
            }
        }
            const response = yield call(api.getSqlStatus)

            
            yield put(actions.setSqlStatus(response));
            let image = response[0].status;
            yield put(actions.setSqlStatusForImage(image));           
            yield put(actions.setStatusPageInitialised(true));
        
        
    } finally {
        yield put(actions.setStatusPageLoading(false));
    }
}

export function* UserProfileConnected(api, action){
    try {
        const initialised = yield (select(selectors.getUserProfileInitialised));
        if (!initialised) {
            yield put(actions.setUserProfileLoading(true));
            
            const response = yield call(api.getUserRole)            
            yield put(actions.setUserRole(response));
            let AadInfo = msalInstance.getAllAccounts()[0];
            let name = AadInfo.name;
            let email = AadInfo.username;   

            let info = [{
                email: email,
                userName: name
            }]

            yield put(actions.setUserInfo(info));              
            yield put(actions.setUserProfileInitialised(true));
        }
    } finally {
        yield put(actions.setUserProfileLoading(false));
    }
}
 
export function* Test(api, action){
    console.log("testing...");
    const response = yield call(api.test);
    console.log(response);      
}

export default function* rootSaga() {
    yield all([ 
        takeEvery([ actions.STATUS_PAGE_LOADED, 
                    actions.REFRESH_STATUS_PAGE],
                                                 StatusPageConnected,  settingsApi),
        takeEvery(  actions.USER_PROFILE_LOADED, UserProfileConnected, settingsApi)      

    ]);
}